import { QuestStatus } from "@joonapp/web-shared"

export const isVercelDeployment =
  window.location.hostname.endsWith(".vercel.app")

export const completeQuestStatuses = [
  QuestStatus.COMPLETED,
  QuestStatus.REDEEMED,
  QuestStatus.VERIFIED,
]

export const notesPlaceholderText: string = `Progress and Observations
- [Note any progress made since the last session]
- [Describe parent's current challenges and strengths]
- [Include relevant observations about parent-child dynamics]

Strategies Discussed and Implemented
- [Strategy 1]: [Brief description and parent's response]
- [Strategy 2]: [Brief description and parent's response]
- [Strategy 3]: [Brief description and parent's response]

Follow-up Items
- [Note any areas requiring additional support or resources]
- [Mention any referrals made or considered]

Additional Notes
[Any other relevant information or observations]
`
